import isNumber from "lodash-es/isNumber";

export default function (value) {
  if (!isNumber(value)) return "NaN!!";
  return value.toLocaleString("ru-RU");
}
